<div class="container-fluid container-fluid-limited">
  <dsd-container>
    <h1 *ngIf="!isAppMobile" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
      {{ titre | translate }}
    </h1>
    <h2 id="titreConfirmation" tabindex="-1">
      {{ 'caad.page-confirmation.sousTitre' | translate }}
    </h2>
    <dsd-alert variant="confirmation" class="dsd-mb-0">
      <h3 slot="title">{{ 'caad.page-confirmation.sousTitre' | translate }}</h3>
      <p>{{ messageAlerte | translate }}</p>
    </dsd-alert>

    <dsd-banner
      hide-close-button="true"
      class="dsd-mt-sm"
      *ngIf="isVueCoordonneesBancaire() && !estProvenanceExterne()">
      <h3 slot="title">{{ 'caad.page-confirmation.coordonnees.banniere.titre' | translate }}</h3>
      <span slot="content">
        <p>
          {{ 'caad.page-confirmation.coordonnees.banniere.message' | translate }}
        </p>
      </span>

      <span slot="actions">
        <dsd-link-action>
          <a [attr.href]="getUrlSecurite()" id="securite" (click)="onClickSecurite()"
            >{{ 'caad.page-confirmation.coordonnees.banniere.lien' | translate }}
          </a>
        </dsd-link-action>
      </span>
    </dsd-banner>
  </dsd-container>
</div>
<app-bouton-retour-parcours-externe *ngIf="estProvenanceExterne()"></app-bouton-retour-parcours-externe>
<app-bouton-retour-coordonnees *ngIf="!estProvenanceExterne() && estBancaireActif()"></app-bouton-retour-coordonnees>
<app-bouton-retour-accueil *ngIf="!estProvenanceExterne() && !estBancaireActif()"></app-bouton-retour-accueil>
